import { render } from "./Inquiry.vue?vue&type=template&id=e18bbe46&scoped=true&ts=true"
import script from "./Inquiry.vue?vue&type=script&lang=ts"
export * from "./Inquiry.vue?vue&type=script&lang=ts"

import "./Inquiry.vue?vue&type=style&index=0&id=e18bbe46&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e18bbe46"]])

export default __exports__